import React, { useState } from 'react';
import { resolveAsset } from '../api/client';

// Square media for a topic tile: the generated cover image, falling back to the
// emoji glyph if the image is missing (e.g. before covers are generated).
export default function TopicMedia({ image, emoji }) {
  const [imgOk, setImgOk] = useState(Boolean(image));
  return (
    <span className="topic-chip-media">
      {imgOk ? (
        <img
          src={resolveAsset(image)}
          alt=""
          className="topic-chip-img"
          onError={() => setImgOk(false)}
        />
      ) : (
        <span className="topic-chip-emoji" aria-hidden="true">{emoji}</span>
      )}
    </span>
  );
}
